// import { useReactTable } from "@tanstack/react-table";

const DebtorBlackList = () => {
  return <h1>Hello</h1>;
};

export default DebtorBlackList;
